import { Navigate } from 'react-router-dom';

/**
 * Post-login landing.
 * The vessel is the stable workspace; refits are selected from the top bar.
 */
export function LandingRedirect() {
  return <Navigate to="/vessel/overview" replace />;
}
